import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

const ALL_QUESTIONS = [
  "Tampilan antarmuka aplikasi AiDuNode menarik secara visual.",
  "Warna dan tema yang digunakan dalam aplikasi terlihat harmonis.",
  "Tata letak menu dan fitur mudah dipahami.",
  "Ukuran teks dalam aplikasi nyaman untuk dibaca.",
  "Ikon dan tombol yang digunakan jelas dan mudah dikenali.",
  "Tampilan aplikasi konsisten di setiap halaman.",
  "Animasi dan transisi dalam aplikasi berjalan dengan halus.",
  "Desain aplikasi terlihat modern dan profesional.",
  "Gambar dan ilustrasi yang digunakan relevan dengan konten.",
  "Aplikasi terlihat menarik di perangkat mobile.",
  "Penggunaan ruang kosong (whitespace) pada aplikasi sudah tepat.",
  "Warna latar belakang aplikasi tidak menyebabkan kelelahan mata.",
  "Desain halaman login terlihat bersih dan profesional.",
  "Desain halaman dashboard informatif dan terorganisir.",
  "Secara keseluruhan, tampilan visual aplikasi memuaskan.",
  "Saya merasa nyaman menggunakan aplikasi ini secara visual.",
  "Aplikasi mudah digunakan tanpa perlu panduan khusus.",
  "Proses registrasi akun baru mudah dan cepat.",
  "Proses login ke dalam aplikasi berjalan lancar.",
  "Menu navigasi aplikasi mudah dipahami dan digunakan.",
  "Saya dapat menemukan fitur yang saya cari dengan cepat.",
  "Alur penggunaan aplikasi terasa intuitif.",
  "Pesan error yang muncul mudah dipahami.",
  "Proses reset password mudah dilakukan.",
  "Fitur pencarian (jika ada) berfungsi dengan baik.",
  "Tombol dan link dalam aplikasi berfungsi sesuai harapan.",
  "Waktu loading halaman terasa wajar dan tidak mengganggu.",
  "Formulir isian dalam aplikasi mudah diisi.",
  "Saya tidak mengalami kebingungan saat menggunakan aplikasi.",
  "Aplikasi memberikan umpan balik yang jelas atas tindakan saya.",
  "Saya dapat menggunakan semua fitur utama tanpa bantuan orang lain.",
  "Secara keseluruhan, aplikasi ini mudah digunakan.",
  "Chatbot AI dapat memahami pertanyaan saya dengan baik.",
  "Jawaban yang diberikan Chatbot AI relevan dengan pertanyaan saya.",
  "Chatbot AI memberikan penjelasan yang mudah dipahami.",
  "Kode Arduino/ESP32 yang dihasilkan Chatbot AI bisa digunakan langsung.",
  "Chatbot AI membantu saya memahami konsep elektronika dengan lebih baik.",
  "Chatbot AI merespons pertanyaan saya dengan cepat.",
  "Chatbot AI mampu menjawab pertanyaan teknis dengan akurat.",
  "Saya merasa puas dengan kualitas jawaban Chatbot AI.",
  "Chatbot AI membantu saya dalam troubleshooting masalah Arduino.",
  "Format tampilan jawaban Chatbot AI (kode, penjelasan) mudah dibaca.",
  "Chatbot AI menjawab dalam bahasa Indonesia dengan baik.",
  "Chatbot AI dapat memberikan contoh rangkaian yang relevan.",
  "Saya akan menggunakan Chatbot AI lagi untuk proyek IoT saya.",
  "Chatbot AI memberikan tips dan saran yang berguna.",
  "Fitur Chatbot AI meningkatkan pengalaman belajar saya.",
  "Secara keseluruhan, fitur Chatbot AI sangat membantu.",
  "Template kode yang tersedia sesuai dengan kebutuhan belajar saya.",
  "Jumlah template kode yang disediakan sudah mencukupi.",
  "Kode dalam template dapat langsung digunakan di Arduino IDE.",
  "Penjelasan pada setiap template kode mudah dipahami.",
  "Kategori template kode tersusun dengan rapi.",
  "Fitur salin (copy) kode berfungsi dengan baik.",
  "Template kode mencakup berbagai jenis sensor yang sering digunakan.",
  "Template untuk ESP32 dan NodeMCU tersedia dan lengkap.",
  "Komentar dalam kode template membantu pemahaman.",
  "Template kode membantu saya memulai proyek dengan lebih cepat.",
  "Saya dapat mempelajari pola pemrograman dari template yang ada.",
  "Template kode membantu saya memahami cara kerja komponen elektronika.",
  "Fitur template kode menghemat waktu dalam mengerjakan proyek.",
  "Saya merasa puas dengan kualitas template kode yang tersedia.",
  "Template kode yang ada relevan dengan kurikulum/pembelajaran IoT.",
  "Secara keseluruhan, fitur Template Kode sangat bermanfaat.",
  "Aplikasi AiDuNode membantu saya belajar Arduino dengan lebih efektif.",
  "Saya merasa lebih percaya diri dalam mengerjakan proyek IoT setelah menggunakan aplikasi ini.",
  "Aplikasi ini menjadi referensi utama saya dalam belajar Arduino/ESP32.",
  "Saya akan merekomendasikan aplikasi ini kepada teman atau rekan.",
  "Aplikasi AiDuNode sesuai dengan kebutuhan belajar saya.",
  "Konten dan fitur aplikasi relevan dengan perkembangan teknologi IoT.",
  "Aplikasi ini membantu saya menyelesaikan tugas/proyek lebih cepat.",
  "Saya merasa aplikasi ini layak digunakan sebagai media pembelajaran.",
  "Fitur-fitur dalam aplikasi saling melengkapi satu sama lain.",
  "Aplikasi AiDuNode memberikan pengalaman belajar yang menyenangkan.",
  "Saya merasa puas dengan performa teknis (kecepatan, stabilitas) aplikasi.",
  "Aplikasi ini mudah diakses dari berbagai perangkat.",
  "Informasi profil saya tersimpan dan ditampilkan dengan benar.",
  "Saya merasa data/akun saya aman menggunakan aplikasi ini.",
  "Aplikasi AiDuNode memenuhi ekspektasi saya secara keseluruhan.",
  "Secara keseluruhan, saya puas menggunakan aplikasi AiDuNode.",
];

const SCALE_LABELS = { 1: "Sangat Tidak Setuju", 2: "Tidak Setuju", 4: "Setuju", 5: "Sangat Setuju" };
const SCALE_COLORS = { 1: "#ef4444", 2: "#f97316", 4: "#3b82f6", 5: "#22c55e" };

function useAdminAuth() {
  const navigate = useNavigate();
  const token = localStorage.getItem("adminToken");
  const admin = JSON.parse(localStorage.getItem("adminData") || "null");
  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminData");
    navigate("/admin/login");
  };
  return { token, admin, logout };
}

/* ═══ Tab: Overview ═══ */
function OverviewTab({ stats, total }) {
  if (!stats || total === 0) {
    return (
      <div className="admin-empty">
        <p>Belum ada data responden.</p>
      </div>
    );
  }

  const allAvgs = Object.values(stats).map(s => parseFloat(s.average)).filter(v => !isNaN(v));
  const globalAvg = allAvgs.length > 0 ? (allAvgs.reduce((a, b) => a + b, 0) / allAvgs.length).toFixed(2) : "-";

  // Top 5 highest & lowest
  const sorted = Object.entries(stats)
    .map(([key, val]) => ({ key, avg: parseFloat(val.average), idx: parseInt(key.replace("q", "")) - 1 }))
    .sort((a, b) => b.avg - a.avg);
  const top5 = sorted.slice(0, 5);
  const bot5 = sorted.slice(-5).reverse();

  return (
    <div className="admin-overview">
      {/* Stats cards */}
      <div className="admin-stat-cards">
        <div className="admin-stat-card blue">
          <span className="admin-stat-icon">👥</span>
          <span className="admin-stat-val">{total}</span>
          <span className="admin-stat-label">Total Responden</span>
        </div>
        <div className="admin-stat-card green">
          <span className="admin-stat-icon">📊</span>
          <span className="admin-stat-val">{globalAvg}</span>
          <span className="admin-stat-label">Rata-rata Skor Global</span>
        </div>
        <div className="admin-stat-card purple">
          <span className="admin-stat-icon">📝</span>
          <span className="admin-stat-val">80</span>
          <span className="admin-stat-label">Total Pertanyaan</span>
        </div>
        <div className="admin-stat-card orange">
          <span className="admin-stat-icon">🎯</span>
          <span className="admin-stat-val">{total * 80}</span>
          <span className="admin-stat-label">Total Jawaban</span>
        </div>
      </div>

      {/* Top & Bottom */}
      <div className="admin-top-bot">
        <div className="admin-top-card">
          <h3 className="admin-sub-title">🏆 5 Pertanyaan Tertinggi</h3>
          {top5.map(item => (
            <div key={item.key} className="admin-rank-row">
              <span className="admin-rank-q">Q{item.idx + 1}</span>
              <span className="admin-rank-text">{ALL_QUESTIONS[item.idx]?.substring(0, 60)}...</span>
              <span className="admin-rank-avg green">{item.avg.toFixed(2)}</span>
            </div>
          ))}
        </div>
        <div className="admin-top-card">
          <h3 className="admin-sub-title">⚠️ 5 Pertanyaan Terendah</h3>
          {bot5.map(item => (
            <div key={item.key} className="admin-rank-row">
              <span className="admin-rank-q">Q{item.idx + 1}</span>
              <span className="admin-rank-text">{ALL_QUESTIONS[item.idx]?.substring(0, 60)}...</span>
              <span className="admin-rank-avg orange">{item.avg.toFixed(2)}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Bar chart semua pertanyaan */}
      <div className="admin-chart-wrap">
        <h3 className="admin-sub-title">📈 Rata-rata Skor per Pertanyaan</h3>
        <div className="admin-bar-chart">
          {Object.entries(stats).map(([key, val], i) => {
            const avg = parseFloat(val.average);
            const pct = ((avg - 1) / 4) * 100;
            const color = avg >= 4 ? "#22c55e" : avg >= 3 ? "#3b82f6" : avg >= 2 ? "#f97316" : "#ef4444";
            return (
              <div key={key} className="admin-bar-item" title={`Q${i + 1}: ${ALL_QUESTIONS[i]}\nRata-rata: ${avg}`}>
                <div className="admin-bar-track">
                  <div className="admin-bar-fill" style={{ height: `${Math.max(pct, 4)}%`, background: color }} />
                </div>
                <span className="admin-bar-label">Q{i + 1}</span>
              </div>
            );
          })}
        </div>
        <div className="admin-bar-legend">
          <span style={{ color: "#22c55e" }}>■ Sangat Baik (≥4)</span>
          <span style={{ color: "#3b82f6" }}>■ Baik (≥3)</span>
          <span style={{ color: "#f97316" }}>■ Cukup (≥2)</span>
          <span style={{ color: "#ef4444" }}>■ Rendah (&lt;2)</span>
        </div>
      </div>
    </div>
  );
}

/* ═══ Tab: Data Responden ═══ */
function RespondentsTab({ responses, onDetail, onDelete }) {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filtered, setFiltered] = useState(responses);
  const [search, setSearch] = useState("");
  const [confirmId, setConfirmId] = useState(null);
  const [confirmName, setConfirmName] = useState("");
  const [deleting, setDeleting] = useState(false);

  useEffect(() => {
    let data = responses;
    if (startDate) data = data.filter(r => new Date(r.createdAt) >= new Date(startDate));
    if (endDate)   data = data.filter(r => new Date(r.createdAt) <= new Date(endDate + "T23:59:59"));
    if (search)    data = data.filter(r => r.user.name.toLowerCase().includes(search.toLowerCase()) || r.user.email.toLowerCase().includes(search.toLowerCase()));
    setFiltered(data);
  }, [startDate, endDate, search, responses]);

  const getAvg = (answers) => {
    const vals = Object.values(answers || {}).filter(v => v);
    return vals.length > 0 ? (vals.reduce((a, b) => a + b, 0) / vals.length).toFixed(2) : "-";
  };

  const handleDeleteClick = (r) => { setConfirmId(r.id); setConfirmName(r.user.name); };
  const handleConfirmDelete = async () => {
    setDeleting(true);
    await onDelete(confirmId);
    setConfirmId(null);
    setDeleting(false);
  };

  return (
    <div className="admin-respondents">
      {confirmId && (
        <div className="admin-modal-overlay">
          <div className="admin-modal confirm">
            <div className="confirm-top">
              <span className="admin-modal-icon">🗑️</span>
              <h3 className="admin-modal-title">Hapus Data Responden?</h3>
              <p className="admin-modal-desc">
                Data kuisioner <strong>{confirmName}</strong> akan dihapus permanen dan tidak bisa dikembalikan.
              </p>
            </div>
            <div className="confirm-bottom">
              <button className="admin-modal-btn cancel" onClick={() => setConfirmId(null)} disabled={deleting}>Batal</button>
              <button className="admin-modal-btn danger" onClick={handleConfirmDelete} disabled={deleting}>
                {deleting ? "⏳ Menghapus..." : "🗑️ Ya, Hapus"}
              </button>
            </div>
          </div>
        </div>
      )}
      <div className="admin-filter-bar">
        <input className="admin-search" placeholder="Cari nama / email..." value={search} onChange={e => setSearch(e.target.value)} />
        <input type="date" className="admin-date-input" value={startDate} onChange={e => setStartDate(e.target.value)} />
        <span>s/d</span>
        <input type="date" className="admin-date-input" value={endDate} onChange={e => setEndDate(e.target.value)} />
        <button className="admin-filter-reset" onClick={() => { setStartDate(""); setEndDate(""); setSearch(""); }}>Reset</button>
      </div>
      <p className="admin-count">Menampilkan {filtered.length} responden</p>
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>No</th><th>Nama</th><th>Email</th><th>Tanggal Isi</th><th>Rata-rata</th><th>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((r, i) => (
              <tr key={r.id}>
                <td>{i + 1}</td>
                <td>{r.user.name}</td>
                <td>{r.user.email}</td>
                <td>{new Date(r.createdAt).toLocaleDateString("id-ID", { day:"2-digit", month:"short", year:"numeric" })}</td>
                <td><span className={`admin-avg-badge ${parseFloat(getAvg(r.answers)) >= 4 ? "green" : parseFloat(getAvg(r.answers)) >= 3 ? "blue" : "orange"}`}>{getAvg(r.answers)}</span></td>
                <td className="admin-action-cell">
                  <button className="admin-detail-btn" onClick={() => onDetail(r)}>Lihat</button>
                  <button className="admin-delete-btn" onClick={() => handleDeleteClick(r)}>Hapus</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ═══ Tab: Export ═══ */
function ExportTab({ token }) {
  const handleExport = () => {
    const url = `${process.env.REACT_APP_API_URL || ""}/api/admin/survey/export`;
    fetch(url, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => res.blob())
      .then(blob => {
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.download = "survey_AiDuNode.csv";
        a.click();
      });
  };

  return (
    <div className="admin-export">
      <div className="admin-export-card">
        <span className="admin-export-icon">📥</span>
        <h3>Export Data CSV</h3>
        <p>Download semua data responden dalam format CSV yang siap diimport ke SPSS atau Excel.</p>
        <ul className="admin-export-info">
          <li>Format: No, Nama, Email, Tanggal, Q1-Q80</li>
          <li>Encoding: UTF-8 dengan BOM (kompatibel Excel Indonesia)</li>
          <li>Nilai: 1 (STS), 2 (TS), 4 (S), 5 (SS)</li>
          <li>Siap digunakan untuk analisis SPSS, R, atau Excel</li>
        </ul>
        <button className="admin-export-btn" onClick={handleExport}>
          ⬇️ Download CSV
        </button>
      </div>
    </div>
  );
}

/* ═══ Detail Modal ═══ */
function DetailModal({ response, onClose }) {
  if (!response) return null;
  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal" onClick={e => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>Detail Jawaban — {response.user.name}</h3>
          <button className="admin-modal-close" onClick={onClose}>✕</button>
        </div>
        <p className="admin-modal-sub">{response.user.email} · {new Date(response.createdAt).toLocaleDateString("id-ID")}</p>
        <div className="admin-modal-body">
          {ALL_QUESTIONS.map((text, i) => {
            const key = `q${i + 1}`;
            const val = response.answers[key];
            const label = SCALE_LABELS[val] || "-";
            const color = SCALE_COLORS[val] || "#999";
            return (
              <div key={key} className="admin-modal-row">
                <span className="admin-modal-qnum">Q{i + 1}</span>
                <span className="admin-modal-qtext">{text}</span>
                <span className="admin-modal-ans" style={{ color, borderColor: color + "55", background: color + "11" }}>
                  {val} - {label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

/* ═══ MAIN ADMIN DASHBOARD ═══ */
export default function AdminDashboard() {
  const navigate = useNavigate();
  const { token, admin, logout } = useAdminAuth();
  const [activeTab, setActiveTab] = useState("overview");
  const [responses, setResponses] = useState([]);
  const [stats, setStats] = useState(null);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [detailData, setDetailData] = useState(null);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const [listRes, statsRes] = await Promise.all([
        api.get("/api/admin/survey", { headers }),
        api.get("/api/admin/survey/stats", { headers }),
      ]);
      setResponses(listRes.data.data || []);
      setTotal(listRes.data.total || 0);
      setStats(statsRes.data.stats || {});
    } catch (err) {
      if (err.response?.status === 401) { logout(); }
    } finally {
      setLoading(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (!token) { navigate("/admin/login"); return; }
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, fetchData]);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/api/admin/survey/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      setResponses(prev => prev.filter(r => r.id !== id));
      setTotal(prev => prev - 1);
    } catch (err) { alert("Gagal menghapus data responden."); }
  };

  const TABS = [
    { id: "overview",    label: "📊 Overview" },
    { id: "respondents", label: "👥 Data Responden" },
    { id: "export",      label: "📥 Export Data" },
  ];

  return (
    <div className="admin-page">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-brand">
          <span className="admin-sidebar-icon">🛡️</span>
          <span>Admin Panel</span>
        </div>
        <nav className="admin-sidebar-nav">
          {TABS.map(t => (
            <button
              key={t.id}
              className={`admin-nav-btn ${activeTab === t.id ? "active" : ""}`}
              onClick={() => setActiveTab(t.id)}
            >
              {t.label}
            </button>
          ))}
        </nav>
        <div className="admin-sidebar-footer">
          <span>{admin?.name || "Admin"}</span>
          <button className="admin-logout-btn" onClick={logout}>Keluar</button>
        </div>
      </aside>

      {/* Main */}
      <div className="admin-main">
        <header className="admin-topbar">
          <h2 className="admin-topbar-title">
            {TABS.find(t => t.id === activeTab)?.label}
          </h2>
          <div className="admin-topbar-right">
            <span className="admin-total-badge">{total} Responden</span>
            <button className="admin-refresh-btn" onClick={fetchData}>🔄 Refresh</button>
          </div>
        </header>

        <div className="admin-content">
          {loading ? (
            <div className="admin-loading">
              <div className="survey-spinner" />
              <p>Memuat data...</p>
            </div>
          ) : (
            <>
              {activeTab === "overview"    && <OverviewTab stats={stats} total={total} />}
              {activeTab === "respondents" && <RespondentsTab responses={responses} onDetail={setDetailData} onDelete={handleDelete} />}
              {activeTab === "export"      && <ExportTab token={token} />}
            </>
          )}
        </div>
      </div>

      {detailData && <DetailModal response={detailData} onClose={() => setDetailData(null)} />}
    </div>
  );
}
